<template>
  <div class="myhome-notifications-page xs-12 m-8 l-9">
    <div class="myhome-notifications-page__go-back">
      <Links
        class="dea-links--large"
        :class="`dea-links--${user.targetCss.colorMod}`"
        icon="go-to"
        type="router-link"
        :to="{ name: 'my-profile-privacy' }"
      >
        Torna alle Impostazioni Privacy e Notifiche
      </Links>
    </div>
    <div class="myhome-notifications-page__list">
      <div class="myhome-notifications-page__list-title dea-heading--medium-m">
        Nuove notifiche
      </div>
      <div v-for="(sent, index) in sentMessages" :key="`sent-${index}`" class="myhome-notifications-page__list-message">
        <div class="myhome-notifications-page__list-message-dot dea-border-feedback-red-negative"></div>
        <div class="dea-heading--regular-s">
          <span class="dea-heading--regular-xs dea-font-grey-medium">{{ formatDate(sent.created_at) }} -</span>
          {{ createLabel(sent) }}
        </div>
      </div>
    </div>
    <div class="myhome-notifications-page__list">
      <div class="myhome-notifications-page__list-title dea-heading--medium-m">
        Notifiche precedenti
      </div>
      <template v-if="readMessages.length === 0">
        <div class="dea-heading--regular-s">
          Nessuna notifica precedente
        </div>
      </template>
      <template v-else>
        <div
          v-for="(read, index) in readMessages"
          :key="`read-${index}`"
          class="myhome-notifications-page__list-message"
        >
          <div class="dea-heading--regular-s">
            <span class="dea-heading--regular-xs dea-font-grey-medium">{{ formatDate(read.created_at) }} -</span>
            {{ createLabel(read) }}
          </div>
        </div>
      </template>
    </div>
    <div v-if="readMessages.length" class="myhome-notifications-page__button">
      <Links class="dea-links--large dea-links--pointer" :disabled="stopDownload" @click="nextMessages">
        Vedi precedenti
      </Links>
      <Loader v-if="loading" />
      <div v-else class="myhome-notifications-page__button-loader-placeholder"></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Links from "@/components/elements/Links";
import Loader from "@/components/elements/Loader";

export default {
  name: "MyProfileNotifications",
  components: { Links, Loader },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      limit: 5,
      loading: false,
      page: 1,
      stopDownload: false,
    };
  },
  async mounted() {
    const payload = { limit: this.limit, page: this.page, user: this.user };
    this.resetReadMessages();
    if (this.$root.config.messages.enable) await this.fetchReadMessages(payload);
  },
  computed: {
    ...mapGetters(["readMessages", "sentMessages"]),
  },
  methods: {
    ...mapActions(["fetchReadMessages", "resetReadMessages"]),
    createLabel(sent) {
      const messageConfig = this.$root.config.messages.priorityOrder.find(el => sent.push.topic === el.topic);
      let newDescription = messageConfig.single.label;
      if (messageConfig.source) {
        const label = messageConfig.source[sent.sender_role]
          ? messageConfig.source[sent.sender_role]
          : messageConfig.source.default;
        newDescription = newDescription.replace("%SOURCE%", label);
      }
      return `${messageConfig.intro} ${newDescription.replace("%NAME%", sent.push.book_name)}`;
    },
    formatDate(time) {
      const date = time.split("T")[0];
      return date
        .split("-")
        .reverse()
        .join("/");
    },
    async nextMessages() {
      if (this.stopDownload) return;

      const token = this.$cookies.get(this.$root.config.api.tokenName);
      const readMessagesBefore = [...this.readMessages];
      this.page += 1;
      const payload = { token, limit: this.limit, page: this.page, user: this.user };
      this.loading = true;
      if (this.$root.config.messages.enable) await this.fetchReadMessages(payload);
      this.loading = false;
      const readMessagesAfter = [...this.readMessages];
      const increment = readMessagesAfter.length - readMessagesBefore.length;
      if (increment < this.limit) {
        this.stopDownload = true;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$dea-loader-dimension: 30px;
$dot-top-relative-position: 5px;
$notification-dot-dimension: 10px;

.myhome-notifications-page {
  &__go-back {
    margin-bottom: $space-large;

    .dea-links {
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-end;

      &__icon {
        transform: rotate(180deg);
      }
    }
  }

  &__list {
    margin-bottom: $space-large;

    &-title {
      margin-bottom: $space-xm-small;
    }

    &-message {
      display: flex;
      flex-direction: row;
      margin-bottom: $space-base;

      &-dot {
        background-color: $dea-color-warning-message;
        border-radius: $border-radius-circle;
        height: $notification-dot-dimension;
        margin-right: $space-x-small;
        min-width: $notification-dot-dimension;
        position: relative;
        text-align: center;
        top: $dot-top-relative-position;
        width: $notification-dot-dimension;
      }
    }
  }

  &__button {
    display: flex;
    flex-direction: row;
    justify-content: center;

    .dea-links {
      margin: 0 $space-x-small;
    }

    .dea-loader {
      margin: 0;

      div {
        height: $dea-loader-dimension !important; //sass-lint:disable-line no-important
        margin: 0 !important; //sass-lint:disable-line no-important
        width: $dea-loader-dimension !important; //sass-lint:disable-line no-important
      }
    }

    &-loader-placeholder {
      height: $dea-loader-dimension;
      width: $dea-loader-dimension;
    }
  }
}
</style>
